import {slideHide, slideToggle} from "./slideBlock";

export function accordion(selector_q, selector_a) {
  const q = document.querySelectorAll(selector_q);
  const a = document.querySelectorAll(selector_a);

  if (q.length > 0 && a.length > 0) {
    q.forEach(e => {
      e.addEventListener('click', () => {
        const next = e.nextElementSibling;
        e.classList.toggle('active');
        slideToggle(next);

        q.forEach(cap => {
          if (cap != e) {
            cap.classList.remove('active');
          }
        });

        a.forEach(con => {
          if (con != next) {
            slideHide(con);
          }
        });
      });
    });
  }
}
